export const SERVER_ERROR_TYPES = {
  INACCESSIBLE_ENTITY: 'AccessControlEntity::InaccessibleEntity',
  SFDC_REQUEST_LIMIT_EXCEEDED:
    'Api::V2::BaseController::SfdcRequestLimitExceeded',
  NOT_AUTHENTICATED: 'Api::V2::BaseController::NotAuthenticatedError',
};
